import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { routes } from '../routes/routes';
import { BaseService } from '../service/base.service';
import { CompleteOnboardingAsBrandDto, CompleteOnboardingAsCreatorDto } from './onboarding.dto';

@Injectable({ providedIn: 'root' })
export class OnboardingService extends BaseService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
  ) {
    super();
  }

  async completeAsBrand(dto: CompleteOnboardingAsBrandDto) {
    await firstValueFrom(this.http.post(`${this.apiUrl}/brands`, dto));
    this.router.navigate([routes.welcome.brand.url()]);
  }

  async completeAsCreator(dto: CompleteOnboardingAsCreatorDto) {
    await firstValueFrom(this.http.post(`${this.apiUrl}/creators`, dto));
    this.router.navigate([routes.welcome.creator.url()]);
  }
}
